'use client'

import {Label} from '../label'
import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import {useController} from 'react-hook-form'
import {createGlobalStyle} from 'styled-components'

import {useFormControl} from '@/src/shared/modules/form'

import flagsStripe from '@/src/shared/assets/media/flags.png'

import * as UI from './form-phone-input.styled'
import {InputProps, MaskedInput} from './input'
import {InputUI, RequiredInputMarkIfNeed, useFormInputProps} from './input/input'
import Select from './select'

export const PhoneInputUI = UI

export type PhoneInputProps = (InputProps & React.PropsWithChildren) | InputProps

const PhoneCountry = {
  Ru: 1,
  By: 2,
  Kz: 3,
}

const PhoneMaskByCountry = {
  [PhoneCountry.Ru]: '+7 (000) 000-00-00',
  [PhoneCountry.By]: '+375 (00) 000-00-00',
  [PhoneCountry.Kz]: '+7 (000) 000-00-00',
}

const countryOptions = [
  {
    value: PhoneCountry.Ru,
    countryName: 'Россия',
    label: (
      <div
        className="img"
        style={{
          background: `url(${flagsStripe.src})`,
          width: 20,
          height: 14,
          backgroundPosition: '-4295px 0px',
          position: 'relative',
        }}
      />
    ),
  },
  {
    value: PhoneCountry.By,
    countryName: 'Беларусь',
    label: (
      <div
        className="img"
        style={{
          background: `url(${flagsStripe.src})`,
          width: 20,
          height: 10,
          backgroundPosition: '-790px 0px',
          position: 'relative',
        }}
      />
    ),
  },
  {
    value: PhoneCountry.Kz,
    countryName: 'Казахстан',
    label: (
      <div
        className="img"
        style={{
          width: 20,
          height: 10,
          background: `url(${flagsStripe.src})`,
          backgroundPosition: '-2853px 0px',
          position: 'relative',
        }}
      />
    ),
  },
]

const FormPhoneInput = observer(({children, ...props}: PhoneInputProps) => {
  const [phoneCountry, setPhoneCountry] = useState<
    (typeof PhoneCountry)[keyof typeof PhoneCountry]
  >(PhoneCountry.Ru)

  const formControl = useFormControl()

  const {field, fieldState} = useController({name: props.name, control: formControl.control})

  const inputProps = useFormInputProps(props, field, fieldState)

  return (
    <>
      <GlobalStyle />
      <UI.Wrapper className={props.className} $disabled={props.disabled}>
        <Styles />

        {children && (
          <Label>
            <RequiredInputMarkIfNeed required={props.required}>{children}</RequiredInputMarkIfNeed>
          </Label>
        )}

        <UI.Control $error={fieldState.invalid && 'error' && true}>
          <UI.Select
            as={Select}
            classNames={{root: UI.Select.styledComponentId}}
            disabled={props.disabled}
            data-testid="phone-country"
            defaultValue={PhoneCountry.Ru}
            optionRender={(option: any) => (
              <div
                className="phone-country-option"
                data-testid="phone-country-option"
                style={{width: 100}}>
                {option.data.label} <span>{option.data.countryName}</span>
              </div>
            )}
            options={countryOptions}
            onChange={countryKey => {
              setPhoneCountry(countryKey)
              field.onChange(null)
            }}
          />

          {/*@ts-ignore TODO:!!! */}
          <InputUI.Input
            as={MaskedInput}
            {...inputProps}
            status=""
            data-testid="phone-input"
            mask={PhoneMaskByCountry[phoneCountry]}
            placeholder={PhoneMaskByCountry[phoneCountry]}
            field={field}
            fieldState={undefined}
            invalid={undefined}
            {...props}
          />
        </UI.Control>
      </UI.Wrapper>
    </>
  )
})

export const Styles = createGlobalStyle`
    .phone-country-option {
      font-weight: normal;
      display: flex;
      align-items: center;
      gap: 10px;
    }
  `

const GlobalStyle = createGlobalStyle`
  .${UI.Select.styledComponentId}.ant-select-dropdown {
    width: auto !important;
  }
`
export default FormPhoneInput
